export class TokenService {
    constructor(config) {
        this.config = config;
    }
    refreshToken() {
        if (this.refreshTokenPromise) {
            return this.refreshTokenPromise;
        }
        this.refreshTokenPromise = this.config
            .refreshToken()
            .then(result => {
            this.refreshTokenPromise = null;
            return result;
        })
            .catch(error => {
            this.refreshTokenPromise = null;
            throw error;
        });
        return this.refreshTokenPromise;
    }
    ensureToken() {
        return this.refreshTokenPromise ? this.refreshTokenPromise : Promise.resolve();
    }
}
//# sourceMappingURL=TokenService.js.map